import { PageNotFound } from './ui/pageNotFound'

export { PAGE_NOT_FOUND_GO_BACK_PROPS } from './ui/pageNotFound'
export default PageNotFound
